module.exports = __webpack_public_path__ + "assets/Heebo-Regular.95723d98119434d418fe51eb89c30838.woff";